<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">
            <div class="body-panel-control-separator">
                <div class="control-block-left">
                    <div class="flex">

                        <project-select :user="info.User" @onChange="onProjectChange" v-if="info.ProjectsLength > 1"></project-select>

                        <div class="form-field margin-right-10">
                            <drop-down :items="[{Id: 1, Name: 'Дата размещения'},{Id: 4, Name: 'Дата выдачи'},{Id: 5, Name: 'Дата скачивания'}]"
                                       :dataField="'Id'"
                                       :textField="'Name'"
                                       v-model="orderDateTypeId"
                                       @change="reload"></drop-down>
                        </div>

                        <div class="input-date-lbl margin-right-10">
                            <input-date name="dateStart" v-model="dateStart" @input="reload" class="input-text input-date"></input-date>
                        </div>
                        <span class="margin-right-10 margin-top-5">-</span>
                        <div class="input-date-lbl">
                            <input-date name="dateEnd" v-model="dateEnd" @input="reload" class="input-text input-date"></input-date>
                        </div>
                        <div class="form-field margin-left-20" v-if="dateStart || dateEnd">
                            <button type="button" class="btn" @click="clearFilterDate">Сбросить</button>
                        </div>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <div style="margin: auto 10px;" v-if="selectedOrders.length">
                            Выбрано {{ selectedOrders.length }} из {{ totalOrders }}
                        </div>

                        <button class="btn" @click="onExport()">
                            Экспорт
                        </button>
                        <button type="button" class="btn"
                                v-if="showProcessAll"
                                @click.stop="processSelected">
                            В работу
                        </button>
                        <button type="button" class="btn"
                                v-if="showCompleteAll"
                                @click.stop="completeSelected">
                            Выдать
                        </button>
                        <button type="button" class="btn"
                                v-if="showGetGifteryAll"
                                @click.stop="makeGifteryOrder(null)">
                            Получить сертификат
                        </button>
                    </div>
                </div>
            </div>
            <div class="body-panel-control-separator">
                <complex-filter
                        ref="complexFilter"
                        :filters="filters"
                        :searchFunction="searchFunction"
                        :tableName="'[dbo].[TradePoint]'"
                        :withTableNameInClause="true"
                        @onFilterChange="onFilterChange"
                        :getByIdFilters="['User','OrderStatus']">
                </complex-filter>
                <button type="button" class="btn" @click.stop="onMarkupTest" style="display:none">
                    Тест вёрстки
                </button>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page scroll-x-ok" @scroll="onScroll">
            <div class="flex btns margin-bottom-10" v-if="rewardTypes.length">
                <button type="button" :class="['btn', {'active': rewardTypeId === 0 }]" @click="rewardTypeId = 0">Все</button>
                <button type="button" v-for="type of rewardTypes" :class="['btn', {'active': rewardTypeId === type }]" @click="rewardTypeId = type">
                    {{ getRewardTypeName(type) }}
                </button>
            </div>

            <table class="table-view" cellspacing="0">
                    <thead>
                    <tr class="heading">
                        <th class="check">
                            <input id="selectAll" name="selectAll" value="true" type="checkbox" class="input-checkbox"
                                   v-model="selectAll" @change="onSelectAllChange" />
                            <label for="selectAll" class="input-checkbox-lbl"></label>
                        </th>
                        <th>Дата</th>
                        <th>Пользователь</th>
                        <th>Баланс</th>
                        <th>Вознаграждение</th>
                        <th>Количество</th>
                        <th>Сумма</th>
                        <th>Статус</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order, i) of orders">
                        <td class="check">
                            <input :id="'select' + i" :value="order" type="checkbox" class="input-checkbox" v-model="selectedOrders" />
                            <label :for="'select' + i" class="input-checkbox-lbl"></label>
                        </td>
                        <td class="datetime-2">
                            <p style="white-space:nowrap"><span>Создан </span>{{ formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm') }}</p>
                            <p style="white-space:nowrap"><span>Выдан </span>{{ formatDate(order.FirstCompleteDate, 'DD.MM.YYYY HH:mm') }}</p>
                            <p style="white-space:nowrap" v-if="order.Reward.RewardType	 !== 3 && order.Reward.RewardType !== 4">
                                <span>Скачан </span>{{ formatDate(order.FirstRecievedDate, 'DD.MM.YYYY HH:mm') }}
                            </p>
<!--                            <p style="white-space:nowrap" v-if="order.Reward.RewardType	=== 4">-->
<!--                                <span>Получен </span>{{ formatDate(order.RecievedDate, 'DD.MM.YYYY HH:mm') }}-->
<!--                            </p>-->
                        </td>
                        <td class="string">#{{order.Id}} {{ order.UserFio }}</td>
                        <td class="valueshort">{{ formatInt(order.UserActiveBalance) }}</td>
                        <td class="datetime string">
                            {{ order.Reward.Name }}
                            <span style="font-style: italic;" v-if="order.Reward.GifteryId">(Giftery)</span>
                        </td>
                        <td class="valueshort">{{ order.Count }}</td>
                        <td class="valueshort">{{ formatInt((order.Amount).toFixed(0)) }}</td>
                        <td class="state">
                            <span class="margin-right-5">{{ getOrderStatus(order) }}</span>

                            <template v-if="order.Reward.RewardType === 1 && order.ExtraData">
                                <button type="button" class="btn btn-img" @click.stop.prevent="onShowExtraDataModal(order.ExtraData, order.Reward.OzonCertificate)" style="display:inline-block;" title="Просмотр сертификата">
                                    <img src="../../img/icon-rep.png" alt="">
                                </button>
                                <button type="button" class="btn btn-img" @click.stop="onCertificateDelete(order.Id)"
                                        v-if="order.Status === 6 && !order.Reward.GifteryId" style="display:inline-block;">
                                    <img src="../../img/icon-del.png" alt="">
                                </button>
                            </template>

                            <template v-if="order.Status === 2 && order.Reward.RewardType === 1 && !order.ExtraData">
                                <template v-if="order.Reward.GifteryId">
                                    <button type="button" class="btn btn-img" title="Получить сертификат"
                                            @click.stop="makeGifteryOrder(order.Id, order.CreateDate)" style="display:inline-block;">
                                        <img src="../../img/replace-icon.png" alt="">
                                    </button>
                                </template>
                                <template v-else-if="order.Reward.OzonCertificate">
                                    <button type="button" class="btn btn-img" title="Получить сертификат"
                                            @click.stop="makeOzonOrder(order)" style="display:inline-block;">
                                        <img src="../../img/replace-icon.png" alt="">
                                    </button>
                                </template>
                                <template v-else>
                                    <input type="file" class="file-upload-zone-btn" accept=".pdf"
                                           :id="'dropFiles' + i"
                                           :ref="'dropFiles' + i"
                                           :name="'dropFiles' + i"
                                           @change="onCertificateChange(order.Id, 'dropFiles' + i)" />
                                    <button type="button" class="btn btn-img" title="Загрузить сертификат"
                                            @click="onCertificateClick('dropFiles' + i)" style="display:inline-block;">
                                        <img src="../../img/replace-icon.png" alt="">
                                    </button>
                                </template>
                            </template>

                            <template v-if="order.Status === OrderStatuses.GifteryDelayed">
                                <img src="../../img/icon-info.png" style="display: inline-block" title="Нажмите для дополнительной информации"
                                     @click.stop="showGifteryOrderHistory(order)">
                            </template>
                        </td>
                        <td class="obtn-short">
                            <div class="btns-col">
                                <button type="button" class="btn btn-img" title="Принять в работу"
                                        v-if="order.Status === 1"
                                        @click="processOrder([order.Id])">
                                    <img src="../../img/icon-flag.png" alt="" />
                                </button>
                                <button type="button" class="btn btn-img" title="Отказать" 
                                        v-if="order.Status === 1 || order.Status === 2 || order.Status === 8"
                                        @click.stop="cancelOrderModal(order)">
                                    <img src="../../img/icon-close.png" alt="" />
                                </button>
                                <button type="button" class="btn btn-img" title="Выдать сертификат пользователю"
                                        v-if="order.Status === 6 && order.Reward.RewardType === 1 && order.ExtraData"
                                        @click="completeOrder([order.Id])">
                                    <img src="../../img/icon-plus-2.png" alt="" />
                                </button>
                                <button type="button" class="btn btn-img"
                                        :title="getCompleteBtnTitle(order)"
                                        v-if="order.Status === 2 && (order.Reward.RewardType === 2 || order.Reward.RewardType === 3 || order.Reward.RewardType === 4)"
                                        @click="completeOrder([order.Id])">
                                    <img src="../../img/icon-plus-2.png" alt="" />
                                </button>
                                <button type="button" class="btn btn-img"
                                        :title="'Адрес доставки'"
                                        :style="{'border-color': (order.AddressConfirmed ? 'green' : 'red') + ' !important'}"
                                        v-if="order.Status === 1 && order.Reward.RewardType === 4"
                                        @click="onAddressModalOpen(order)">
                                    <img src="../../img/icon-home.png" alt="" />
                                </button>
                                <button type="button" class="btn btn-img" title="Получен"
                                        v-if="order.Status === 4 && order.Reward.RewardType === 4"
                                        @click.stop="receiveOrderModal(order)">
                                    <img src="../../img/icon-date.png" alt="" />
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
        </div>


        <popup-window ref="ppCancelModal" :title="'Отмена заказа'">
            <div class="form-group">
                <label class="input-text-lbl">
                    Напишите причину отказа
                </label>
                <textarea name="Comment" rows="10" style="height:150px; width: 100%;" ref="Comment" class="input-memo"></textarea>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="cancelOrder()">Готово</button>
                <button type="button" class="btn" @click="closeModal('ppCancelModal')">Отмена</button>
            </div>

        </popup-window>

        <popup-window ref="ppActionModal" :title="'Обработка заказов'" :modal="true">
            <div class="form-group">
                <p v-if="!actionState.done">
                    Заказ {{actionState.currentOrder.index}} / {{actionState.total}} от {{formatDate(actionState.currentOrder.date, 'DD.MM.YYYY HH:mm')}} в процессе {{actionState.currentOrder.time}} сек.
                </p>
                <p v-else>
                    <template v-if="actionState.doneMessage">
                        {{actionState.doneMessage}}
                    </template>
                    <template v-else>
                        Обработка завершена
                    </template>
                </p>
                <div class="margin-top-20" style="max-height:300px;overflow:auto;">
                    <p v-for="m of actionState.messages" :style="m.error ? 'color:red': ''" class="caption-help">
                        {{m.message}}
                    </p>
                </div>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn" @click="ppActionModalClose" v-if="actionState.done || actionState.test">Закрыть</button>
            </div>

        </popup-window>

        <popup-window ref="ppExtraData" :title="'Сертификат'" :modal="true" :width="800">
            <div ref="ppExtraDataContainer" style="height: 300px;">
            </div>

            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn" @click="closeModal('ppExtraData')">Закрыть</button>
            </div>

        </popup-window>

        <popup-window ref="ppAddress" :title="'Адрес доставки'" :modal="true" :width="800">
            <template v-if="address.data != null">
                <div class="form-field" v-if="address.list.length > 1">

                    <drop-down :items="address.list"
                               :dataField="'Id'"
                               :textField="'DisplayAddress'"
                               v-model="address.addressId"
                               @change="onAddressChange"></drop-down>
                </div>
                <div class="form-field">
                    <label class="input-text-lbl">Получатель</label>
                    <input name="addressFio" type="text"
                           v-validate="{required: true}"
                           v-model="address.data.Fio"
                           data-vv-as="Фио"
                           data-vv-scope="address"
                           :class="['input-text', {'input-error': errors.has('addressFio', 'address')}]"
                    />
                    <span class="field-validation-valid">{{ errors.first('addressFio') }}</span>
                </div>
                <div class="form-field">
                    <label class="input-text-lbl">Телефон</label>
                    <the-mask :mask="'# (###) ###-##-##'" name="addressPhoneNumber"
                              v-model="address.data.PhoneNumber"
                              v-validate="{ required: true, regex: /^\d{11}$/ }"
                              data-vv-scope="address"
                              data-vv-as="Телефон"
                              :class="['input-text', {'input-error': errors.has('addressPhoneNumber', 'address')}]" />
                    <span class="field-validation-valid">{{ errors.first('addressPhoneNumber') }}</span>
                </div>
                <div class="form-field">
                <label class="input-text-lbl">Адрес</label>
                <input name="addressFullAddress" type="text"
                       v-validate="{required: true}"
                       v-model="address.data.FullAddress"
                       data-vv-as="Адрес"
                       data-vv-scope="address"
                       :class="['input-text', {'input-error': errors.has('addressFullAddress', 'address')}]"
                />
                <span class="field-validation-valid"></span>
            </div>

            </template>

            <template v-slot:footer>
                <div class="popup-footer">
                    <div class="btns flex margin-top-20" data-toggle="buttons">
                        <button type="button" class="btn" @click="closeModal('ppAddress')">Закрыть</button>
                        <button type="button" class="btn" @click="onAddressConfirm">Подтвердить адрес</button>
                    </div>
                </div>
            </template>
        </popup-window>

        <popup-window ref="ppReceiveOrder" :title="'Получение заказа'" :modal="true">
            <div class="form-group">
                <label class="input-text-lbl">
                    Отметьте дату получения
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="input-date-lbl">
                    <input-date name="ReceiveDateFormatted"
                                v-model="receiveDateFormatted"
                                v-validate="'required'"
                                data-vv-scope="receive"
                                data-vv-as="Дата получения"
                                @input="onChangeReceiveDate()"
                                :class="['input-text', {'input-error': errors.has('ReceiveDateFormatted', 'receive')}]"></input-date>
                </div>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="receiveOrder()">Готово</button>
                <button type="button" class="btn" @click="closeModal('ppReceiveOrder')">Отмена</button>
            </div>

        </popup-window>

        <popup-window ref="ppOrderHistory" :title="'История получения заказа'" :modal="true" :width="800">
            <div class="margin-bottom-10">
                <p>Сертификат: <b>{{ orderHistory.sert_name }}</b>, номинал: <b>{{ orderHistory.sert_nominal }}</b></p>
            </div>
            <div class="margin-bottom-10">
                {{getDelayedTitle(orderHistory.id)}}
                <p v-if="orderHistory.nextTryingDate">
                    Следующая попытка получить: {{ orderHistory.nextTryingDate | date-long }}
                </p>
            </div>
            <div v-if="orderHistory.data !== null && orderHistory.data[0].StatusId === OrderStatuses.OrdersMonitoringTry">
                <button type="button" class="btn btn-primary margin-top-10" @click.stop="onCheckGiftery(orderHistory.data[0].GifteryId)">Проверить доступные номиналы</button>
                <span v-if="orderHistory.giftery.loading">Идёт загрузка...</span>
                <div v-else-if="orderHistory.giftery.data" class="margin-top-5">
                    В данный момент доступны: {{ orderHistory.giftery.data.join(', ') }}
                </div>
            </div>
            <div v-if="orderHistory.data == null">
                Идёт загрузка...
            </div>
            <table class="table-view margin-top-20">
                <thead style="display: table-header-group !important;">
                    <tr>
                        <th>Дата</th>
                        <th>Статус</th>
                        <th>Комментарий</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, u) of orderHistory.data">
                        <td>
                            {{ item.ActionDate | date-long }}
                        </td>
                        <td>
                            {{ getOrderStatus({Status: item.StatusId}) }}
                        </td>
                        <td>
                            <div v-if="item.GifteryQueueId">Id заявки в Giftery: {{item.GifteryQueueId}}</div>
                            <div v-if="item.GifteryQueueId">Id вознаграждения в Giftery: {{item.GifteryId}}</div>
                            <div class="margin-top-5">{{ item.Comment }}</div>

                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="$refs['ppOrderHistory'].close()">Ok</button>
            </div>

        </popup-window>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import UI from '../helpers/ui-helpers'
    import moment from 'moment'
    import config from '../config'
    import {OrderStatuses, RewardTypes} from '../enums'

    let backendApi = new BackendApi();

    const rowsPerPage = 50;

    let processFilter = function(filter){
        let resultFilter = JSON.parse(JSON.stringify(filter));
        for (let item of resultFilter) {
            let filterField = item[0];
            if(filterField === '[dbo].[TradePoint].[OrderStatus]'){
                item[0] = '[dbo].[Order].[StatusId]';
            }
            if(filterField === '[dbo].[TradePoint].[User]') {
                item[0] = '[dbo].[Order].[UserId]';
            }
            if(filterField === '[dbo].[TradePoint].[Reward]') {
                item[0] = '[dbo].[Reward].[Id]';
            }
        }

        return resultFilter;
    };

    export default {
        name: "orders",

        props: ['info'],

        mixins: [projectMixin],

        data(){
            return {
                orders: [],
                selectedOrderId: null,
                uploadedFile: null,
                roles: [],
                filter: null,
                dateStart: null,
                dateEnd: null,
                orderDateTypeId: 1,
                orderStatus: 0,
                OrderStatuses: OrderStatuses,
                filters: [
                    {
                        Value: 'OrderStatus', Name: 'Статус'
                    },
                    {
                        Value: 'Name', Name: 'Название'
                    },
                    {
                        Value: 'Region', Name: 'Регион'
                    },
                    {
                        Value: 'Area', Name: 'Область'
                    },
                    {
                        Value: 'City', Name: 'Город'
                    },
                    {
                        Value: 'Address', Name: 'Адрес'
                    },
                    {
                        Value: 'User', Name: 'Пользователь'
                    },
                    {
                        Value: 'Reward', Name: 'Вознаграждение'
                    }
                ],
                selectAll: false,
                selectedOrders: [],
                isLoading: false,
                canBeLoaded: true,
                page: 1,
                actionState: {
                    currentOrder: {
                        index: 0,
                        date: null,
                        time: 0
                    },
                    total: 0,
                    messages: [],
                    done: false
                },
                totalOrders: 0,
                rewardTypes:[],
                rewardTypeId: 0,
                address: {
                    addressId: null,
                    list: [],
                    data: null
                },
                receiveDate: null,
                receiveDateFormatted: null,
                orderHistory: {
                    data: null,
                    id: null,
                    nextTryingDate: null,
                    giftery: {
                        loading: false,
                        data: null
                    }
                }
            }
        },

        watch: {
            rewardTypeId() {
                this.reload();
            }
        },

        computed:{
            showProcessAll(){
                return this.selectedOrders.filter((x) => {
                    return x.Status === 1 /*&& x.UserActiveBalance >= x.Amount*/;
                }).length > 0;
            },

            showCompleteAll() {
                return this.selectedOrders.filter((x) => {
                    return (x.Status === 2 && (x.Reward.RewardType === 2 || x.Reward.RewardType === 3 || x.Reward.RewardType === 4)) || (x.Status === 6 && x.Reward.RewardType === 1 && x.ExtraData);
                }).length > 0;
            },

            showGetGifteryAll(){
                return this.selectedOrders.filter((x) => {
                    return x.Reward.GifteryId && x.Status === 2 && x.Reward.RewardType === 1 && !x.ExtraData;
                }).length > 0;
            }
        },

        methods:{
            onCheckGiftery(gifteryId){
                let vm = this;

                vm.orderHistory.giftery.loading = true;

                return backendApi.gifteryProducts().then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке продуктов Giftery');
                    }
                    else {
                        //console.log('response.data', response.data);
                        let item = response.data.find(x => x.id == gifteryId);
                        if(!item){
                            UI.toastr.error('Данный сертификат не найден в ответе Gifteri.');
                            return;
                        }
                        vm.orderHistory.giftery.data = item.faces;
                    }
                    vm.orderHistory.giftery.loading = false;
                });
            },

            showGifteryOrderHistory(order){
                let vm = this;
                vm.$refs['ppOrderHistory'].show();
                vm.orderHistory.data = null;
                vm.orderHistory.id = order.Id;
                vm.orderHistory.nextTryingDate = null;
                vm.orderHistory.giftery.data = null;
                vm.orderHistory.sert_name = order.Reward.Name;
                vm.orderHistory.sert_nominal = order.Amount;
                vm.loadOrderHistory(order.Id);
            },

            loadOrderHistory(id) {
                let vm = this;
                this.callApiWrapper(backendApi.orderHistory(id))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки адреса');
                        } else {
                            console.info('loadOrderHistory -> resp.data', resp);
                            vm.orderHistory.data = resp.data.filter(x => x.StatusId === OrderStatuses.GifteryRequested
                                || x.StatusId === OrderStatuses.GifteryDelayed
                                || x.StatusId === OrderStatuses.OrdersMonitoringTry);

                            let lastTryingDate = _.max(vm.orderHistory.data.filter( x => x.StatusId === OrderStatuses.OrdersMonitoringTry).map(x => x.ActionDate));
                            if(lastTryingDate){
                                vm.orderHistory.nextTryingDate = moment(lastTryingDate).add(1, 'hours');
                            }
                        }
                    });
            },

            getDelayedTitle(orderId) {
                let order = this.orders.find(x => x.Id === orderId);
                if(order && order.GifteryDelayedDate) {
                    return 'Автоматическое получение с ' +
                        this.formatDate(order.GifteryDelayedDate, 'DD.MM.YYYY') + ' по ' +
                        this.formatDate(moment(order.GifteryDelayedDate).add(7, 'days'), 'DD.MM.YYYY');
                }
                return '';
            },

            getCompleteBtnTitle(order){
                if(order.Reward.RewardType === 2)
                    return 'Отметить, что карта отправлена';
                else if (order.Reward.RewardType === 3)
                    return 'Отметить, что перевод произведён';
                else if (order.Reward.RewardType === 4)
                    return 'Выдать';

                return '';
            },

            onAddressModalOpen(order){
                this.address.data = null;
                this.address.list = [];
                this.loadAddresses(order.AddressId, order.UserId);
                this.$refs['ppAddress'].show();
            },

            loadAddresses(addressId, userId) {
                let vm = this;
                this.callApiWrapper(backendApi.orderAddressList(userId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки адреса');
                        } else {
                            for(let addr of resp.data){
                                addr.DisplayAddress = addr.FullAddress.length > 100 ? (addr.FullAddress.substring(0, 100) + '...') : addr.FullAddress;
                            }

                            vm.address.addressId = addressId;
                            vm.address.data = resp.data.find(x => x.Id === addressId);

                            vm.address.list = resp.data;
                        }
                    });
            },

            onAddressChange(address){
                this.address.data = address;
            },

            onAddressConfirm() {
                let vm = this;
                this.$validator.validateAll('address').then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    } else {
                        vm.callApiWrapper(backendApi.orderConfirmAddress(vm.address.data))
                            .then(function (resp) {
                                if (resp.hasError && resp.status !== 401) {
                                    UI.toastr.error('Ошибка во время подтверждения адреса');
                                } else {
                                    UI.toastr.success('Адрес подтверждён');
                                    vm.reload();
                                    vm.$refs['ppAddress'].close();
                                }
                            });
                    }
                });
            },

            getRewardTypeName(type) {
                switch (type) {
                    case RewardTypes.ElectronicGiftCard:
                        return 'Электронный сертификат';
                    case RewardTypes.PrepaidBankCard:
                        return 'Предоплаченная карта';
                    case RewardTypes.PhysicalBankCard:
                        return 'Выплата на карту';
                    case RewardTypes.PhysicalPrize:
                        return 'Физические призы';
                    default:
                        return '';
                }
            },

            onShowExtraDataModal(extraData, showText) {
                this.$refs['ppExtraData'].show();
                this.$nextTick(() => {
                    if (showText)
                        this.$refs.ppExtraDataContainer.innerHTML = '<h3>' + extraData + '</h3>';
                    else
                        this.$refs.ppExtraDataContainer.innerHTML = UI.pdf_view(extraData);
                });
            },

            reload(){
                this.page = 1;
                this.canBeLoaded = true;
                this.orders = [];
                this.selectedOrders = [];
                this.selectAll = false;
                this.loadOrders();
            },

            loadRoles() {
                let vm = this;
                let projectId = vm.projectId;
                
                return this.callApiWrapper(backendApi.rolesList(projectId))
                    .then(function (resp) {
                        if (resp.data) {

                            vm.roles = resp.data.Roles;

                            /*
                            для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                            если роль не связана с ТТ, то она видит все роли связанные с ТТ
                            если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                            */
                            if(vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess))
                            {
                                //alert()
                                for(let r = 0; r < vm.roles.length; r++) {
                                    if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                        vm.filters.push({
                                            Value: 'TradePointRole_' + vm.roles[r].Id,
                                            Name: vm.roles[r].Name
                                        });
                                    }
                                }
                            }
                            else{

                                for(let r = 0; r < vm.roles.length; r++) {
                                    if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess) && vm.info.User.DynamicRole.Order < vm.roles[r].Order) {

                                        vm.filters.push({
                                            Value: 'TradePointRole_' + vm.roles[r].Id,
                                            Name: vm.roles[r].Name
                                        });
                                    }
                                }
                            }
                        }

                    });
            },

            loadOrders() {
                let vm = this;
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').format();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').format();
                let filterFormatted = '';
                if(vm.filter){
                    filterFormatted = processFilter(vm.filter).map(x => { return JSON.stringify(x) });
                    //console.log('filterFormatted', filterFormatted);
                }

                vm.isLoading = true;
                UI.blockUI('.dataContent', 'Загрузка...');
                this.callApiWrapper(backendApi.ordersList((this.page - 1) * rowsPerPage, rowsPerPage, vm.projectId, dateStart, dateEnd, vm.orderDateTypeId, vm.orderStatus, filterFormatted, vm.rewardTypeId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки заказов');
                        }
                        else {
                            if (resp.data && resp.data.list.length) {
                                vm.orders.push(...resp.data.list);

                                vm.totalOrders = resp.data.totalOrders;

                                vm.rewardTypes = resp.data.rewardTypes;
                                // if(vm.selectAll) {
                                //     for(let order of vm.orders){
                                //         vm.selectedOrders.push(order);
                                //     }
                                // }
                            }
                            else{
                                vm.canBeLoaded = false;
                            }

                        }

                        UI.unblockUI('.dataContent');
                        vm.isLoading = false;
                    });
            },

            // В работу
            processOrder(orderIds){
                let vm = this;

                UI.blockUI('dataContent', 'Обработка');
                this.callApiWrapper(backendApi.orderProcess(orderIds))
                    .then(function (response) {
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            console.info('error status', response.status);
                            if (response.status === 600) {
                                UI.toastr.error('У пользователя недостаточо средств');
                            }
                            else if (response.status === 606) {
                                UI.toastr.error('Адрес не подтвержден');
                            }
                            else {
                                UI.toastr.error('Ошибка при обработке заказа');
                            }
                        }
                        else{
                            if(orderIds.length === 1)
                            {
                                UI.toastr.success('Заказ принят в работу');
                            }else{
                                UI.toastr.success('Заказы обработаны');
                            }

                            // todo: можно не делать полный релоад, а только заменить статус
                            vm.reload();
                        }
                    });
            },

            // Отклонить заказ - модальное окно
            cancelOrderModal(order){
                let vm = this;

                vm.selectedOrderId = order.Id;
                vm.$nextTick(() => {
                    vm.$refs.ppCancelModal.show();
                });
            },

            // Отклонить заказ
            cancelOrder(){
                if(confirm('Заказ будет отменён, вы уверены?')) {
                    let vm = this;
                    let comment = this.$refs.Comment.value;

                    UI.blockUI('dataContent', 'Отмена заказа');
                    this.callApiWrapper(backendApi.orderCancel(vm.selectedOrderId, comment))
                        .then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при отмене заказа');
                                console.info('error status', response.status)
                            }
                            else {
                                UI.toastr.success('Заказ успешно отменён');

                                vm.reload();
                            }
                            vm.$refs.ppCancelModal.close();
                        });
                }
            },

            receiveOrderModal(order){
                let vm = this;

                vm.selectedOrderId = order.Id;
                vm.$nextTick(() => {
                    vm.$refs.ppReceiveOrder.show();
                });
            },

            // Отметить приз как полученный
            receiveOrder(){
                this.$validator.validateAll('receive').then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    } else {
                        let vm = this;

                        UI.blockUI('dataContent', 'Получение заказа');
                        this.callApiWrapper(backendApi.orderReceiveWithDate(vm.selectedOrderId, this.receiveDate))
                            .then(function (response) {
                                UI.unblockUI('.dataContent');
                                if (response.hasError) {
                                    UI.toastr.error('Ошибка при получении заказа');
                                    console.info('error status', response.status)
                                } else {
                                    UI.toastr.success('Заказ успешно отмечен как полученный');
                                    vm.reload();
                                }
                                vm.$refs.ppReceiveOrder.close();
                            });
                    }
                });
            },

            onChangeReceiveDate() {
                this.receiveDate = moment(this.receiveDateFormatted, 'DD.MM.YYYY').format();
            },

            // Пометить как выданный
            completeOrder(orderIds){
                let vm = this;

                UI.blockUI('dataContent', 'Обработка');
                this.callApiWrapper(backendApi.orderComplete(orderIds))
                    .then(function (response) {
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            console.info('error status', response.status);
                            if (response.status === 603) {
                                UI.toastr.error('Нельзя обработать заказ в текущем статусе');
                            }
                            else if(response.status === 605) {
                                UI.toastr.error('К заказу не прикреплён файл');
                            }
                            else if( response.status=== 202)
                            {
                                UI.toastr.error('Изменения сохранены. Но возникла ошибка при отправке писем');
                            }
                            else {
                                UI.toastr.error('Ошибка при обработке заказа');
                            }
                        }
                        else{
                            if(orderIds.length === 1)
                            {
                                UI.toastr.success('Заказ отмечен как выданный');
                            }else{
                                UI.toastr.success('Заказы обработаны');
                            }

                            // todo: можно не делать полный релоад, а только заменить статус
                            vm.reload();
                        }
                    });
            },

            closeModal(popupName){
                this.$refs[popupName].close();
            },

            getOrderStatus(order) {
                switch (order.Status) {
                    case 1:
                        return 'Размещён';
                    case 2:
                        return 'Обработка';
                    case 3:
                        return 'Отменён';
                    case 4:
                        if (order.Reward && (order.Reward.RewardType === 1 || order.Reward.RewardType === 3 || order.Reward.RewardType === 4)) {
                            // Электронная подарочная карта, приз
                            return 'Выдан';
                        } else if (order.Reward && order.Reward.RewardType === 2) {
                            // Предоплаченная банковская карта
                            return 'Выдан (карта отправлена)';
                        } else {
                            return 'Выдан';
                        }
                    case 5:
                        if (order.Reward && order.Reward.RewardType === 1) {
                            // Электронная подарочная карта
                            return 'Скачан';
                        } else if (order.Reward && order.Reward.RewardType === 2) {
                            // Предоплаченная банковская карта
                            return 'Карта получена';
                        } else if (order.Reward && order.Reward.RewardType === 4) {
                            // приз
                            return 'Получен';
                        }
                        else {
                            return 'Получен';
                        }
                    case 6:
                        return 'Готов к выдаче';
                    case 7:
                        return 'Обработка заявки';
                    case 8:
                        return 'Отложенное получение';
                    case 101:
                        return 'Ошибка получения в Giftery';
                    default:
                        return '';
                }
            },

            onProjectChange(item){
                let vm = this;

                vm.projectId = item.Id;
                vm.orders = [];
                vm.page = 1;
                vm.canBeLoaded = true;

                vm.filter = null;
                vm.$refs.complexFilter.clear();

                vm.loadRoles().then(function(){
                    vm.loadOrders();
                });
                vm.$emit('user-updated');
            },

            onFilterChange(filter) {
                this.filter = filter;
                this.reload();
            },

            // todo: fix
            searchFunction(tableName, columnName, search, filters, searchPage, callback) {
                let projectId = this.projectId;
                let filterFormatted = '';
                if (filters) {
                    filterFormatted = processFilter(filters).map(x => {
                        return JSON.stringify(x)
                    });
                }

                this.callApiWrapper(backendApi.orderDistinctValues(columnName, projectId, search, filterFormatted, (searchPage - 1) * 100, 100))
                    .then(function (resp) {
                        callback(resp.data);
                    })
            },

            onSelectAllChange(){
                let vm = this;

                vm.selectedOrders = [];
                if(vm.selectAll) {
                    for (let order of vm.orders) {
                        vm.selectedOrders.push(order);
                    }
                }
            },

            completeSelected(){
                let vm = this;

                vm.actionState = {
                    currentOrder: {
                        index: 0,
                        date: null,
                        time: 0
                    },
                    total: 0,
                    messages: [],
                    done: false
                };

                vm.$refs.ppActionModal.show();

                (async function loop() {
                    UI.blockUI('dataContent', 'Обработка');

                    let selectedOrders = vm.selectedOrders.map(x => x.Id);
                    let secondsInterval;
                    vm.actionState.total = selectedOrders.length;
                    for (let id of selectedOrders) {
                        vm.actionState.currentOrder.index++;
                        vm.actionState.currentOrder.time = 0;
                        let order = vm.orders[vm.orders.findIndex(x => x.Id === id)];
                        vm.actionState.currentOrder.date = order.CreateDate;

                        secondsInterval = setInterval(function () {
                            vm.actionState.currentOrder.time += 1;
                        }, 1000);
                        await vm.callApiWrapper(backendApi.orderComplete([id]))
                            .then(function (response) {
                                clearInterval(secondsInterval);

                                let orderTitle = `Заказ ${vm.actionState.currentOrder.index} от ${vm.formatDate(vm.actionState.currentOrder.date, 'DD.MM.YYYY HH:mm')}`;
                                if (response.hasError) {
                                    if (response.status === 603) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Неверный статус заказа`,
                                            error: true
                                        });
                                    }
                                    else if (response.status === 605) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Не прикреплён сертификат`,
                                            error: true
                                        });
                                    }
                                    else {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Ошибка при обработке`,
                                            error: true
                                        });
                                    }
                                }
                                else {
                                    vm.actionState.messages.push({message: `${orderTitle}: Выдан`});
                                }

                                if (vm.actionState.currentOrder.index === vm.actionState.total) {
                                    vm.actionState.done = true;
                                    UI.unblockUI('dataContent');
                                }
                            });
                    }
                })();
            },

            processSelected(){
                let vm = this;

                vm.actionState = {
                    currentOrder: {
                        index: 0,
                        date: null,
                        time: 0
                    },
                    total: 0,
                    messages: [],
                    done: false
                };

                vm.$refs.ppActionModal.show();

                (async function loop() {
                    UI.blockUI('dataContent', 'Обработка');

                    let selectedOrders = vm.selectedOrders.map(x => x.Id);
                    let secondsInterval;
                    vm.actionState.total = selectedOrders.length;
                    for (let id of selectedOrders) {
                        vm.actionState.currentOrder.index++;
                        vm.actionState.currentOrder.time = 0;
                        let order = vm.orders[vm.orders.findIndex(x => x.Id === id)];
                        vm.actionState.currentOrder.date = order.CreateDate;

                        secondsInterval = setInterval(function () {
                            vm.actionState.currentOrder.time += 1;
                        }, 1000);
                        await vm.callApiWrapper(backendApi.orderProcess([id]))
                            .then(function (response) {
                                clearInterval(secondsInterval);

                                let orderTitle = `Заказ ${vm.actionState.currentOrder.index} от ${vm.formatDate(vm.actionState.currentOrder.date, 'DD.MM.YYYY HH:mm')}`;
                                if (response.hasError) {
                                    if (response.status === 600) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: У пользователя недостаточо средств`,
                                            error: true
                                        });
                                    }
                                    else if (response.status === 603) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Неверный статус заказа`,
                                            error: true
                                        });
                                    }
                                    else if (response.status === 606) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Адрес не подтвержден`,
                                            error: true
                                        });
                                    }
                                    else {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Ошибка при обработке`,
                                            error: true
                                        });
                                    }
                                }
                                else {
                                    vm.actionState.messages.push({message: `${orderTitle}: Принят в работу`});
                                }

                                if (vm.actionState.currentOrder.index === vm.actionState.total) {
                                    vm.actionState.done = true;
                                    UI.unblockUI('dataContent');
                                }
                            });
                    }
                })();
            },

            ppActionModalClose() {
                this.closeModal('ppActionModal');
                this.reload();
            },

            onMarkupTest() {
                var mess = [];
                this.actionState = {
                    currentOrder: {
                        index: 1,
                        date: new Date(),
                        time: 2
                    },
                    total: 5,
                    messages: mess,
                    done: false,
                    test: true
                };
                var rn = 0;
                setInterval(function () {
                    rn++;
                    mess.push({
                        message: 'Заказ ' + rn + ' от 26.07.2019 14:27: Принят в работу', error: false
                    }) }, 500);
                this.$refs.ppActionModal.show();
            },

            onCertificateClick(dropFiles) {
                let vm = this;
                vm.$refs[dropFiles][0].click();
            },

            onCertificateDelete(orderId) {
                let vm = this;
                if (confirm('Удалить сертификат?')) {
                    UI.blockUI('dataContent', 'Удаление сертификата');
                    vm.callApiWrapper(backendApi.orderExtraDataRemove(orderId))
                        .then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при удалении сертификата');
                                console.info('error status', response.status)
                            }
                            else {
                                UI.toastr.success('Сертификата успешно удален');

                                vm.reload();
                            }
                        });
                }
            },

            onCertificateChange(orderId, dropFiles){
                let vm = this;

                if (vm.$refs[dropFiles][0].files && vm.$refs[dropFiles][0].files[0]) {
                    if (vm.$refs[dropFiles][0].files[0].size > 50 * 1024 * 1024) {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                    } else {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            let fileData = e.target.result;
                            let fileName = vm.$refs[dropFiles][0].files[0].name;

                            UI.blockUI('dataContent', 'Загрузка сертификата');
                            vm.callApiWrapper(backendApi.orderExtraData(orderId, fileData, fileName))
                                .then(function (response) {
                                    UI.unblockUI('.dataContent');
                                    if (response.hasError) {
                                        if(response.status === 2001){
                                            UI.toastr.error('Неверный формат файла');
                                        }
                                        else{
                                            UI.toastr.error('Ошибка при загрузке сертификата');
                                        }
                                        console.info('error status', response.status)
                                    }
                                    else {
                                        UI.toastr.success('Сертификат успешно загружен');

                                        vm.orders = [];
                                        vm.page = 1;
                                        vm.canBeLoaded = true;
                                        vm.loadOrders();
                                    }
                                });

                        };
                        reader.readAsDataURL(this.$refs[dropFiles][0].files[0]);
                    }

                }
            },

            onScroll(e){
                let vm = this;
                if (!vm.isLoading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.page++;
                        vm.loadOrders();
                    }
                }
            },

            onExport(){
                let vm = this;

                let projectId = vm.projectId;
                let dateStart = moment(vm.dateStart, 'DD.MM.YYYY').format();
                let dateEnd = moment(vm.dateEnd, 'DD.MM.YYYY').format();

                let filterFormatted = '';
                let pf = [];
                if (vm.filter) {
                    pf = processFilter(vm.filter);
                }
                if (vm.selectedOrders.length > 0) {
                    let selectedOrders = vm.selectedOrders.map(x => x.Id);
                    pf.push(['[dbo].[Order].[Id]', 'IN', '(' + `${encodeURIComponent(selectedOrders.join(",")).replace("'", "''")}` + ')']);
                }
                if (pf.length > 0) {
                    filterFormatted = pf.map(x => { return JSON.stringify(x) });
                }

                UI.blockUI('#app');
                this.callApiWrapper(backendApi.ordersExport(projectId, dateStart, dateEnd, filterFormatted, vm.orderDateTypeId, vm.orderStatus))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                            console.info('resp', resp);
                        }
                        else {
                            let exportFile = resp.data;
                            if(exportFile != null)
                            {
                                UI.downloadFileByBytes(exportFile, "Заказы.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            makeGifteryOrder(id){
                let vm = this;

                vm.actionState = {
                    currentOrder: {
                        index: 0,
                        date: null,
                        time: 0
                    },
                    total: 0,
                    messages: [],
                    done: false,
                    ordersToCheck: {},
                    doneMessage: null
                };

                vm.$refs.ppActionModal.show();

                (async function loop() {
                    UI.blockUI('dataContent', 'Обработка');

                    let selectedOrders = id? [id]: vm.selectedOrders.map(x => x.Id);
                    console.info('selectedOrders', selectedOrders);

                    let secondsInterval;
                    vm.actionState.total = selectedOrders.length;
                    for (let id of selectedOrders) {
                        vm.actionState.currentOrder.index++;
                        vm.actionState.currentOrder.time = 0;
                        let order = vm.orders.find(x => x.Id === id);
                        vm.actionState.currentOrder.date = order.CreateDate;

                        secondsInterval = setInterval(function () {
                            vm.actionState.currentOrder.time += 1;
                        }, 1000);
                        await vm.callApiWrapper(backendApi.makeGifteryOrder(id))
                            .then(function (response) {
                                clearInterval(secondsInterval);

                                let orderTitle = `Статус для заказа #${vm.actionState.currentOrder.index} от ${vm.formatDate(vm.actionState.currentOrder.date, 'DD.MM.YYYY HH:mm')}`;
                                if (response.hasError) {
                                    if (response.status === 603) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Не верный статус заказа`,
                                            error: true
                                        });
                                    }
                                    else if (response.status === 3001) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Номинал временно не поддерживается`,
                                            error: true
                                        });
                                    }
                                    else if (response.status === 3002) {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Не достаточно средств`,
                                            error: true
                                        });
                                    }
                                    else {
                                        vm.actionState.messages.push({
                                            message: `${orderTitle}: Ошибка при обработке`,
                                            error: true
                                        });
                                    }
                                }
                                else {
                                    vm.actionState.messages.push({id: id, message: `${orderTitle}: заявка оформлена`});
                                    vm.actionState.ordersToCheck[id] = true;
                                }

                                if (vm.actionState.currentOrder.index === vm.actionState.total) {
                                    vm.actionState.done = true;
                                    vm.actionState.doneMessage = 'Создание заявок завершено.';
                                    if(Object.keys(vm.actionState.ordersToCheck).length){
                                        vm.actionState.doneMessage += ' Идёт получение сертификатов';
                                    }
                                    UI.unblockUI('dataContent');
                                }
                            });

                        if(vm.actionState.currentOrder.index === 1){
                            vm.runGifteryOrdersMonitoring();
                        }
                    }
                })();
            },

            runGifteryOrdersMonitoring(){
                let vm = this;

                let checkInterval = setInterval(function () {
                    let orderIds = Object.keys(vm.actionState.ordersToCheck);
                    console.info('orderIds', orderIds);
                    if(!orderIds.length){
                        clearInterval(checkInterval);
                        return false;
                    }

                    vm.callApiWrapper(backendApi.getOrderStatuses(orderIds))
                        .then(function (response) {
                            for(let order of response.data){
                                if(order.StatusId === OrderStatuses.ReadyToComplete){
                                    delete vm.actionState.ordersToCheck[order.Id];

                                    let item = vm.actionState.messages.find(x => x.id === order.Id);
                                    if(item) {
                                        item.message += ', сертификат получен';
                                    }
                                }
                            }

                            if(!Object.keys(vm.actionState.ordersToCheck).length && vm.actionState.done){
                                console.log('Завершаем runGifteryOrdersMonitoring');
                                clearInterval(checkInterval);
                                vm.actionState.doneMessage += '. Сертификаты получены';
                            }
                        });

                }, 5000);
            },

            makeOzonOrder(order) {
                let vm = this;

                UI.blockUI('dataContent', 'Сохранение');
                this.callApiWrapper(backendApi.makeOzonOrder(order.Id))
                    .then(function (response) {
                        //console.info('orderPlace -> response.data', response.data);
                        UI.unblockUI('.dataContent');
                        let orderTitle = `Статус для заказа #${order.Id} от ${vm.formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm')}`;
                        if (response.hasError) {
                            if (response.status === 603) {
                                UI.toastr.error(`${orderTitle}: Не верный статус заказа`);
                            }
                            else if (response.status === 3001) {
                                UI.toastr.error(`${orderTitle}: Номинал временно не поддерживается`);
                            }
                            else {
                                UI.toastr.error(`${orderTitle}: Ошибка при обработке`);
                            }
                            UI.toastr.error('Ошибка при размещении заказа');
                            // todo: customize
                        } else {
                            UI.toastr.success('Заказ успешно размещён');
                            order.Status = response.data.status;
                        }
                    });
            },

            clearFilterDate() {
                this.dateStart = null;
                this.dateEnd = null;
                this.orderDateTypeId = 1;

                this.reload();
            }
        },

        mounted(){
            let vm = this;

            vm.loadRoles().then(function(){
                vm.loadOrders();

            });
            vm.$refs.complexFilter.applyFilter();

        }
    }
</script>

<style scoped>
    .table-view thead{
        display: table-header-group;
    }
    .table-view td.state .certificate{
        align-items: center;
        margin-top: 5px;
    }
    .info-error{
        border: 1px solid #ef0348;
        border-radius: 15px;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/Orders.vue